import styled from '@emotion/styled';
import { variant } from 'styled-system';
import { StyledProps as Props, Theme } from './Logo.types';

const color = (text: string, comma: string) => ({
  '.text': {
    fill: text,
  },
  '.comma': {
    fill: comma,
  },
});

export default styled.svg<Props, Theme>`
  ${variant({
    variants: {
      light: color('#fce5df', '#ea544a'),
      normal: color('#ea544a', '#66102d'),
      dark: color('#66102d', '#ea544a'),
    },
  })}
`;
